/**
 * Theme constants for PixiJS rendering
 * Mirrors the CSS variables from the DOM-based implementation
 */

export const COLORS = {
  // Brand
  PRIMARY: 0x3b82f6,
  BORDER: 0x4a5568,

  // Backgrounds
  BG_PRIMARY: 0x1a1a2e,
  BG_SECONDARY: 0x16213e,
  BG_TERTIARY: 0x0f3460,

  // Tiles
  TILE: 0x2a2a4a,
  TILE_HOVER: 0x3a3a6a,
  TILE_VALID_MOVE: 0x22c55e,
  TILE_VALID_DASH: 0x3b82f6,
  TILE_ATTACK: 0xef4444,
  TILE_SELECTED: 0xf59e0b,

  // Players
  PLAYER1: 0x3b82f6,
  PLAYER2: 0xef4444,

  // Status
  SUCCESS: 0x22c55e,
  DANGER: 0xef4444,
  WARNING: 0xf59e0b,

  // Text
  TEXT_PRIMARY: 0xffffff,
  TEXT_SECONDARY: 0x94a3b8,
  TEXT_MUTED: 0x64748b,

  // Health bar
  HEALTH_HIGH: 0x22c55e,
  HEALTH_MEDIUM: 0xf59e0b,
  HEALTH_LOW: 0xef4444,

  // Rarity
  RARITY_COMMON: 0x94a3b8,
  RARITY_UNCOMMON: 0x22c55e,
  RARITY_RARE: 0x3b82f6,
  RARITY_EPIC: 0xa855f7,
  RARITY_LEGENDARY: 0xf59e0b,
} as const;

export const FONTS = {
  PRIMARY: 'Segoe UI, system-ui, -apple-system, sans-serif',
  SIZES: {
    XS: 10,
    SM: 12,
    MD: 16,
    LG: 20,
    XL: 28,
    XXL: 36,
    TITLE: 48,
  },
} as const;

export const LAYOUT = {
  BOARD_SIZE: 5,
  TILE_GAP: 4,
  HUD_WIDTH: 280,
  CARD_WIDTH: 240,
  CARD_HEIGHT: 320,
  BUTTON_HEIGHT: 44,
  BUTTON_PADDING: 16,
  BORDER_RADIUS: 8,
} as const;

export const ANIMATION = {
  MOVE_DURATION: 0.3,
  FADE_DURATION: 0.3,
  PULSE_DURATION: 0.5,
  HOVER_DURATION: 0.15,
} as const;

export const ALPHA = {
  TILE_HIGHLIGHT: 0.3,
  INACTIVE_HUD: 0.6,
  DISABLED: 0.5,
  HOVER: 0.8,
} as const;

export const SPACING = {
  XS: 4,
  SM: 8,
  MD: 16,
  LG: 24,
  XL: 32,
} as const;
